export const ACTIVITY_ACTIONS = {
  ROUNDUP: 'roundup',
  CUSTOM: 'custom',
  RECURRING: 'recurring',
  SIGNUP: 'signup',
  MONTHLY_DONATION_CREATED: 'monthly_donation_created',
  ROUNDUP_ACCOUNT_CREATED: 'roundup_account_created',
  TICKET_SOLD: 'ticket_sold',
};
